import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/pcHome.vue'
import About from '@/views/pcAbout.vue'
import Product from '@/views/pcProduct.vue'
import Honor from '@/views/pcHonor.vue'
import Project from '@/views/pcProject.vue'
import WapProduct from '@/views/wapProduct.vue'
import WapHome from '@/views/wapHome.vue'
import WapHonor from '@/views/wapHonor.vue'
import WapProject from '@/views/wapProject.vue'
import WapAbout from '@/views/wapAbout.vue'

const isProd = process.env.NODE_ENV === 'production'
const originalPush = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)


export default new VueRouter({
  mode: isProd ? 'history' : 'history',
  routes: [
    {
      path: '/',
      redirect: {
        name: 'home'
      }
    },
    {
      path: '/pc-home',
      name: 'home',
      component: Home
    },
    {
      path: '/pc-about',
      name: 'about',
      component: About
    },
    {
      path: '/pc-product',
      name: 'product',
      component: Product
    },
    {
      path: '/pc-honor',
      name: 'honor',
      component: Honor
    },
    {
      path: '/pc-project',
      name: 'project',
      component: Project
    },
    {
      path: '/wap-product',
      name: 'wapProduct',
      component: WapProduct
    },
    {
      path: '/wap-home',
      name: 'wapHome',
      component: WapHome
    },
    {
      path: '/wap-honor',
      name: 'wapHonor',
      component: WapHonor
    },
    {
      path: '/wap-project',
      name: 'wapProject',
      component: WapProject
    },
    {
      path: '/wap-about',
      name: 'wapAbout',
      component: WapAbout
    }
  ]
})



// WEBPACK FOOTER //
// src/router/index.js